import {accountApi} from "../../utils/api";

export const getRoles = () => {
    return accountApi.get('/roles')
}

export const getRoleDescription = (id  ) => {
  const role = roles.find(el => el.id === id)
  return role ? role.description : ""
}
export const roles = [
    {
        "id": "a00daea9-9148-40b1-b643-b9b2a1eda584",
        "role": "WBHO & Operations",
        "posted_ts": "2024-01-07T13:34:42.844Z",
        description: "Gets complete access to all documents, form settings, and  access to view some responses\n"
    },
    {
        "id": "1dea2876-a4dc-45d1-b6d2-84eb807d48a9",
        "role": "Resettlement Supervisor",
        "posted_ts": "2024-01-07T13:36:05.651Z",
        description: "Gets access to all functionalities of resettlement compensation process\n"
    },
    {
        "id": "709d9c38-f348-487a-bb90-da88bbf9abbc",
        "role": "Data management manager",
        "posted_ts": "2024-01-07T13:36:43.020Z",
        description: `Gets access to recheck and view all responses, Geofence, Form settings, Access Todo, View real time analytics dashboard, Access Questions, Access Reports`
    },
    {
        "id": "6706ddcb-d4f6-4dd8-b7ef-fdace39136fc",
        "role": "Environmental Team",
        "posted_ts": "2024-01-07T13:37:15.987Z",
        description: "Gets access to recheck responses, view some responses, access all documents, view real time analytics dashboard"
    },
    {
        "id": "559ad953-94f0-4929-a8ef-ec940cb3cca1",
        "role": "Validation team",
        "posted_ts": "2024-01-07T13:37:44.451Z",
        description: `Gets access to recheck responses, all documents, Change farmer status from "Pending" to "Verified", View real time analytics dashboard, Form settings, Geofence, Reports, View responses`
    },
    {
        "id": "01e2bf40-de22-4397-9c4a-e204d9ae1c0c",
        "role": "CFO",
        "posted_ts": "2024-01-07T13:38:01.483Z",
        description:  "Gets access to view realtime analytics dashboard, change some compensation status, view some responses"
    },
    {
        "id": "fb7281db-40d4-428f-aa90-0fc07aa2d3fd",
        "role": "Finance officer",
        "posted_ts": "2024-01-07T13:38:14.371Z",
        description: "Gets access to recheck responses, view realtime analytics dashboard, view some responses\n"
    },
]
